import React from 'react';
import { Container, PauseButton } from './Styles';

const VAStartStop = ({
  show,
  onClick,
  bgColor,
  bgVariance,
  color,
  icon,
  isLanePaused,
  iconOnly,
  label,
  pressed,
  currentAuctionId,
  auctionLaneId,
}) => {
  const getButtonText = () => {
    if (iconOnly) return null;
    if (label) return label;
    return !isLanePaused ? 'STOP E-LANE' : 'START E-LANE';
  };

  return (
    <>
      {show && (
        <Container>
          <PauseButton
            onClick={() => onClick(currentAuctionId, auctionLaneId)}
            bgColor={bgColor}
            color={color}
            bgVariance={bgVariance}
            pressed={pressed}
          >
            <i className={`fa ${icon}  fa-2`} aria-hidden="true" />
            {getButtonText()}
          </PauseButton>
        </Container>
      )}
    </>
  );
};

export default VAStartStop;
